export default __webpack_public_path__ + "static/media/block1_img.f4652759.png";